import { render, staticRenderFns } from "./1966793477014491137.vue?vue&type=template&id=4152e8ca&scoped=true"
import script from "./1966793477014491137.vue?vue&type=script&lang=js"
export * from "./1966793477014491137.vue?vue&type=script&lang=js"
import style0 from "./1966793477014491137.vue?vue&type=style&index=0&id=4152e8ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4152e8ca",
  null
  
)

export default component.exports